<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row" style="margin-top: 100px">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Tunai</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalTunai | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Transfer Bank</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalTransfer | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Giro</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalGiro | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Uang Muka</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalUangMuka | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Tunai Report</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalTunaiReport | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Transfer Report</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalTransferReport | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Giro Report</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalGiroReport | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Uang Muka Report</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalUangMukaReport | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                    <h4 class="text-primary">Laporan Pembayaran Supplier</h4>
                    <div class="form-inline">
                      <span><b>Company:</b></span>
                      <select v-model="company_no" class="form-control">
                        <option value="">-- All --</option>
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                      <span><b>Vendor:</b></span>
                      <v-select :options="selectVendor" :reduce="vendor => vendor.meta.code" label="vendor" v-model="vendor_no" class="vsc-custom vsc-custom-inline"/>
                      <span><b>Date:</b></span>
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                      <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                      <button class="btn btn-sm btn-soft-primary" @click="processReport2">Process</button>
                      <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-print" aria-hidden="true"></i> Print
                      </button>
                      <div class="dropdown-menu" aria-labelledby="print">
                        <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                        <ul class="nav nav-tabs nav-bordered">
                          <li class="nav-item"><a href="#purchasing" data-toggle="tab" aria-expanded="false" class="nav-link active">Purchasing</a></li>
                          <!-- <li class="nav-item"><a href="#purchasing-group" data-toggle="tab" aria-expanded="false" class="nav-link">Purchasing by group</a></li> -->
                          <li class="nav-item"><a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a></li>
                        </ul>
                        <div class="tab-content">
                          <div class="tab-pane active" id="purchasing">
                            <div class="table-responsive">
                              <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <thead>
                                  <th>#</th>
                                  <th>Ref No.</th>
                                  <th>Type</th>
                                  <th>Method</th>
                                  <th>Vendor</th>
                                  <th>Date</th>
                                  <th class="text-right">Retur</th>
                                  <th class="text-right">Uang Muka</th>
                                  <th class="text-right">Subtotal</th>
                                  <th class="text-right">Discount</th>
                                  <th class="text-right">Tax</th>
                                  <th class="text-right">Round</th>
                                  <th class="text-right">Payment</th>
                                  <th class="text-right">Total</th>
                                  <th class="text-right">Outstanding</th>
                                </thead>
                                <tbody>
                                  <tr v-for="s in dataRaw2" :key="s.id">
                                    <td>
                                      <label v-if="s.type === 'payment'" class="form-checkbox">
                                        <input type="checkbox" :value="s.id" v-model="selected" @change="uncheckReportPayment(s.id, s.ref_no)"><i class="form-icon"></i>
                                      </label>
                                    </td>
                                    <td>
                                      <span v-if="s.type === 'purchasing'" class="ml-5 text-ref-sales" @click="showPurchasingNo(s.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ s.ref_no}}</span>
                                      <span v-else-if="s.type === 'sales'" class="ml-5 text-ref-sales" @click="showSaleNo(s.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.ref_no}}</span>
                                      <span v-else data-toggle="modal" @click="showPaymentNo(s.ref_no)" data-target="#modalPaymentGroup" data-backdrop="static" data-keyboard="false"><b>{{ s.ref_no }}</b></span>
                                    </td>
                                    <td>
                                      <span class="badge badge-success" v-if="s.type === 'payment'">{{ s.type }}</span>
                                      <span class="badge badge-primary" v-else-if="s.type === 'sales'">{{ s.type }}</span>
                                      <span class="badge badge-warning" v-else>{{ s.type }}</span>
                                    </td>
                                    <td>
                                        <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                        <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                        <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                    </td>
                                    <td>
                                      <span v-if="s.type === 'sales'">{{ s.customer }}</span>
                                      <span v-else>{{ s.vendor }}</span>
                                    </td>
                                    <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td class="text-right">{{ s.retur_total | currency }}</td>
                                    <td class="text-right">{{ s.uangmuka | currency }}</td>
                                    <td class="text-right">{{ s.subtotal | currency }}</td>
                                    <td class="text-right">{{ s.discount | currency }}</td>
                                    <td class="text-right">{{ s.tax | currency }}</td>
                                    <td class="text-right">{{ s.round | currency }}</td>
                                    <td class="text-right">{{ s.payment_amount | currency }}</td>
                                    <td class="text-right">{{ s.total | currency }}</td>
                                    <td class="text-right">{{ s.outstanding | currency }}</td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td colspan="13" class="text-right"><b>Total Potong Nota (sales)</b></td>
                                    <td class="text-right">{{ totalNotaSales | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="13" class="text-right"><b>Total Tunai</b></td>
                                    <td class="text-right">{{ totalTunaiReport | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="13" class="text-right"><b>Total Transfer</b></td>
                                    <td class="text-right">{{ totalTransferReport | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="13" class="text-right"><b>Total Giro</b></td>
                                    <td class="text-right">{{ totalGiroReport | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="13" class="text-right"><b>Total Uang Muka</b></td>
                                    <td class="text-right">{{ totalUangMukaReport | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="13" class="text-right"><b>Total</b></td>
                                    <td class="text-right">{{ totalTunaiReport + totalTransferReport + totalGiroReport + totalUangMukaReport | currency }}</td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                          <div class="tab-pane" id="purchasing-group">
                              <div v-for="i in dataRaw" :key="i.id">
                                  <h5 style="margin-top: 50px" class="text-center"><b>{{ i.vendor_no }}</b> - {{ i.vendor }}</h5>
                                  <div class="table-responsive">
                                      <table class="table table-item mb-0 table-sm table-striped table-hover">
                                          <thead>
                                              <th>#</th>
                                              <th>Ref No.</th>
                                              <th>Type</th>
                                              <th>Method</th>
                                              <th>Vendor</th>
                                              <th>Date</th>
                                              <th>Due Date</th>
                                              <th class="text-right">Retur</th>
                                              <th class="text-right">Uang Muka</th>
                                              <th class="text-right">Subtotal</th>
                                              <th class="text-right">Discount</th>
                                              <th class="text-right">Tax</th>
                                              <th class="text-right">Round</th>
                                              <th class="text-right">Payment</th>
                                              <th class="text-right">Total Sales</th>
                                              <th class="text-right">Outstanding</th>
                                          </thead>
                                          <tbody>
                                              <tr v-for="s in i.purchasing" :key="s.id">
                                                  <td>
                                                      <label v-if="s.type === 'payment'" class="form-checkbox">
                                                        <input type="checkbox" :value="s.id" v-model="selected" @change="uncheckReportPayment(s.id, s.ref_no)"><i class="form-icon"></i>
                                                      </label>
                                                  </td>
                                                  <td>
                                                      <span v-if="s.type === 'purchasing'" class="ml-5 text-ref-sales" @click="showSaleNo(s.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.ref_no}}</span>
                                                      <span v-else><b>{{ s.ref_no }}</b></span>
                                                  </td>
                                                  <td>
                                                      <span class="badge badge-success" v-if="s.type === 'payment'">{{ s.type }}</span>
                                                      <span class="badge badge-warning" v-else>{{ s.type }}</span>
                                                  </td>
                                                  <td>
                                                      <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                                      <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                                      <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                                  </td>
                                                  <td>{{ s.vendor }}</td>
                                                  <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                                  <td>{{ s.due_date | dateFormat('DD/MM/YYYY')}}</td>
                                                  <td class="text-right">{{ s.retur_total | currency }}</td>
                                                  <td class="text-right">{{ s.uangmuka | currency }}</td>
                                                  <td class="text-right">{{ s.subtotal | currency }}</td>
                                                  <td class="text-right">{{ s.discount | currency }}</td>
                                                  <td class="text-right">{{ s.tax | currency }}</td>
                                                  <td class="text-right">{{ s.round | currency }}</td>
                                                  <td class="text-right">{{ s.payment_amount | currency }}</td>
                                                  <td class="text-right">{{ s.total | currency }}</td>
                                                  <td class="text-right">{{ s.outstanding | currency }}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                          <div class="tab-pane" id="summary">
                              <h5>Summarys</h5>
                              <div class="row">
                                <div class="col-md-6">
                                  <pre>{{ dataRaw2 }}</pre>
                                </div>
                                <div class="col-md-6">
                                  <pre>{{ totalNotaSales }}</pre>
                                </div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <PaymentGroupModal />
    <PurchasingModal />
    <SaleModal />
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { paymentUrl, reportTransactionUrl, reportUrl, purchasing2Url, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import PaymentGroupModal from '@/components/payment/PaymentGroupModal.vue'
import SaleModal from '@/components/sales/SaleModal.vue'

export default {
  name: 'PurchasingReportPayment',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    PurchasingModal,
    PaymentGroupModal,
    SaleModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      vendor_no: '',
      loadingSales: true,
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      dataRaw2: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getVendorList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser,
      vendorList: state => state.vendors.vendorList
    }),
    totalNotaSales () {
      var array = this.dataRaw2.filter(d => d.type === 'sales')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        console.log(array[i].payment_amount)
        sum += parseFloat(array[i].payment_amount)
      }
      return sum
    },
    selectVendor () {
      var array = this.vendorList
      var loop = [{
        vendor: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          vendor: '[' + array[a].vendor_no + '] ' + array[a].name,
          meta: {
            code: array[a].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    groupData () {
      var result = []
      return result
    },
    totalUangMuka () {
      var sum = 0
      var array = this.dataRaw2
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Uang Muka') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalUangMukaReport () {
      var sum = 0
      var array = this.dataRaw2.filter(d => d.report_count > 0)
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Uang Muka') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalGiro () {
      var sum = 0
      var array = this.dataRaw2
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Giro') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalGiroReport () {
      var sum = 0
      var array = this.dataRaw2.filter(d => d.report_count > 0)
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Giro') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalTunai () {
      var sum = 0
      var array = this.dataRaw2
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Tunai') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalTunaiReport () {
      var sum = 0
      var array = this.dataRaw2.filter(d => d.report_count > 0)
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Tunai') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalTransfer () {
      var sum = 0
      var array = this.dataRaw2
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Transfer Bank') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalTransferReport () {
      var sum = 0
      var array = this.dataRaw2.filter(d => d.report_count > 0)
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Transfer Bank') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    async showPaymentNo (id) {
      var payload = {
        group_no: id
      }
      this.$store.commit('SET_PAYMENT_BY_NO', payload)
      this.$store.dispatch('getPaymentByNo', payload)
    },
    async processReport () {
      this.$Progress.start()
      this.loader.isLoading = true
      // var dateReport = new Date()
      // dateReport = dateReport.getFullYear() + '-' + (dateReport.getMonth() + 1) + '-' + dateReport.getDate()
      for (let c = 0; c < this.selected.length; c++) {
        for (let b = 0; b < this.dataRaw.length; b++) {
          var purchasing = this.dataRaw[b].purchasing
          for (let a = 0; a < purchasing.length; a++) {
            if (purchasing[a].id === this.selected[c]) {
              console.log(purchasing[a])
              var obj = {
                payment_no: purchasing[a].ref_no,
                company_no: purchasing[a].company_no,
                report_date: purchasing[a].date,
                username: this.authUser.username,
                notes: null
              }
              console.log(obj)
              console.log(reportTransactionUrl + '/create-payment-purchasing')
              await axios.post(reportTransactionUrl + '/create-payment-sales', obj, { headers: getHeader() })
                .then(response => {
                  console.log(response.data.message)
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                  this.$swal('Error', error.response.data.message, 'error')
                  throw error
                })
              var type = purchasing[a].method_id
              var body = {
                id: purchasing[a].id,
                purchasing_no: purchasing[a].purchasing_no
              }
              if (type === 4) {
                await axios.post(paymentUrl + '/journal-purchasing-um', body, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error', error.response.data.message, 'error')
                  })
              } else {
                console.log()
                await axios.post(paymentUrl + '/journal-purchasing', body, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error', error.response.data.message, 'error')
                  })
              }
            }
          }
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport2 () {
      this.$Progress.start()
      this.loader.isLoading = true
      // var dateReport = new Date()
      // dateReport = dateReport.getFullYear() + '-' + (dateReport.getMonth() + 1) + '-' + dateReport.getDate()
      for (let c = 0; c < this.selected.length; c++) {
        var purchasing = this.dataRaw2
        for (let a = 0; a < purchasing.length; a++) {
          if (purchasing[a].id === this.selected[c]) {
            var obj = {
              payment_no: purchasing[a].ref_no,
              company_no: purchasing[a].company_no,
              report_date: purchasing[a].date,
              username: this.authUser.username,
              notes: null
            }
            console.log(obj)
            console.log(reportTransactionUrl + '/create-payment-purchasing')
            await axios.post(reportTransactionUrl + '/create-payment-purchasing', obj, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
            if (purchasing[a].level === 1) {
              var type = purchasing[a].method_id
              var body = {
                id: purchasing[a].id
              }
              if (type === 4) {
                await axios.post(paymentUrl + '/journal-purchasing-um', body, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error', error.response.data.message, 'error')
                  })
              } else {
                console.log(body)
                await axios.post(paymentUrl + '/journal-purchasing', body, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error', error.response.data.message, 'error')
                  })
              }
            }
          }
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.refreshList()
    },
    async uncheckReportPayment (id, refNo) {
      console.log(id)
      console.log(refNo)
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        vendor_no: this.vendor_no
      }
      console.log(reportUrl + '/payment-by-vendor')
      await axios.post(reportUrl + '/payment-by-vendor', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw2 = response.data.data
          for (let i = 0; i < this.dataRaw2.length; i++) {
            if (this.dataRaw2[i].report_count > 0) {
              this.selected.push(this.dataRaw2[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw2
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(purchasing2Url + '/payment-by-vendor', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
